import ChangeBillingPlan from "../components/private/Billing/ChangeBillingPlan";
import CounterPartyBilling from '../components/private/Billing/CounterPartyBilling';
import CreateContract from "../components/private/Contracts/CreateContract";
import EditContract from "../components/private/Contracts/EditContract";
import CreateCounterParty from "../components/private/Counterparties/CreateCounterparty";
import EditCounterParty from "../components/private/Counterparties/EditCounterParty";
import CreateExternalDest from "../components/private/Destinations/ExternalDest/CreateExternalDest";
import EditExternalDest from "../components/private/Destinations/ExternalDest/EditExternalDest";
import CreateInternalDest from "../components/private/Destinations/InternalDest/CreateInternalDest";
import EditInternalDest from "../components/private/Destinations/InternalDest/EditInternalDest";
import CreateCommodity from "../components/private/FarmInformation/parts/Commodities/CreateCommodity";
import EditCommodity from "../components/private/FarmInformation/parts/Commodities/EditCommodity";
import CreateCommVariety from "../components/private/FarmInformation/parts/CommodityVarietes/CreateCommVariety";
import EditCommVariety from "../components/private/FarmInformation/parts/CommodityVarietes/EditCommVariety";
import CreateFieldGroup from "../components/private/FarmInformation/parts/FieldGroups/CreateFieldGroup";
import EditFieldGroup from "../components/private/FarmInformation/parts/FieldGroups/EditFieldGroup";
import {
  default as Field,
  default as FieldGroupInfo,
  default as LoadNoIndicator
} from "../components/private/FarmInformation/parts/FieldGroups/FieldGroupInfo";
import CreateField from "../components/private/FarmInformation/parts/FieldGroups/Fields/CreateField";
import EditField from "../components/private/FarmInformation/parts/FieldGroups/Fields/EditField";
import CreateLoadNoIndicator from "../components/private/FarmInformation/parts/FieldGroups/LoadNumberIndicators/CreateLoadNoIndicator";
import EditLoadNoIndicator from "../components/private/FarmInformation/parts/FieldGroups/LoadNumberIndicators/EditLoadNoIndicator";
import CreateSubFarm from "../components/private/FarmManagment/CreateSubFarm";
import EditMainFarm from "../components/private/FarmManagment/EditMainFarm";
import EditSubFarm from "../components/private/FarmManagment/EditSubFarm";
import FarmManagement from "../components/private/FarmManagment/FarmManagement";
import FarmsList from "../components/private/FarmManagment/FarmsList";
import FarmSetup from "../components/private/FarmSetup";
import HarvestYearManagemnet from "../components/private/HarvestYear/HarvestYearManagement";
import LoginHome from "../components/private/LoginHome";
import Reconciliation from "../components/private/Reconciliation/Reconciliation";
import CounterpartyConnection from "../components/private/Counterparties/CounterpartyConnection"
import Reports from "../components/private/Reports";
import RiskManagement from "../components/private/RiskManagement";
import Settings from "../components/private/Settings";
import ShowHelpText from "../components/private/ShowHelpText";
import CreateTicket from "../components/private/Tickets/CreateTicket";
import EditTicket from "../components/private/Tickets/EditTicket";
import CreateTruckline from "../components/private/Trucklines/CreateTruckline";
import EditTruckline from "../components/private/Trucklines/EditTruckline";
import ChangePassword from "../components/private/UserManagement/ChangePassword";
import EditAnyUser from "../components/private/UserManagement/EditAnyUser";
import UserManagement from "../components/private/UserManagement/UserManagement";
import CreateUser from "../components/private/Users/CreateUser";
import EditUser from "../components/private/Users/EditUser";
import { Profile } from "../components/PrivateComponents";
import MainFarmForm from "../components/public/MainFarmForm";
import Products from "../components/public/Purchase/Products";
import CounterpartyTicketview from "../components/private/Tickets/CounterpartyTicketview";
import { userDetail } from "../../src/config/userDetails";

export default {
  Profile: {
    component: Profile,
    path: "/profile"
  },
  Home: {
    component: LoginHome,
    path: "/app"
  },
  CounterpartyTicketview: {
    component: CounterpartyTicketview,
    path: "/CounterpartyTicketview"
  },
  FarmUtilities: {
    component: (userDetail().roleName==="ACCOUNT_OWNER" || userDetail().roleName==="ACCOUNT_ADMIN" || userDetail().roleName==="FARM_EMPLOYEE") ?Products:LoginHome,
    path: "/farm-utilities"
  },
  ConnectionManagement: {
    component:  userDetail().roleName==="COUNTER_PARTY"? CounterpartyConnection:LoginHome,

    path:"/connection-management"
  },
  CreateTicket: {
    component: CreateTicket,
    path: "/app/createticket"
  },
  CreateContract: {
    component: CreateContract,
    path: "/app/createcontract"
  },
  EditContract: {
    component: EditContract,
    path: "/app/editcontract"
  },
  EditTicket: {
    component: EditTicket,
    path: "/app/editTicket"
  },
  Dashboard: {
    component: LoginHome,
    path: "/app/dashboard"
  },
  Tickets: {
    component: LoginHome,
    path: "/app/tickets"
  },
  CounterPartyTickets: {
    component: LoginHome,
    path: "/app/counterPartytickets"
  },
  Contracts: {
    component: LoginHome,
    path: "/app/contracts"
  },
  FarmSetup: {
    component: FarmSetup,
    path: "/farmsetup"
  },
  CreateTruckline: {
    component: CreateTruckline,
    path: "/farmsetup/trucklines/create"
  },
  EditTruckline: {
    component: EditTruckline,
    path: "/farmsetup/trucklines/edit"
  },
  CreateInternalDest: {
    component: CreateInternalDest,
    path: "/farmsetup/destinations/internal/create"
  },
  EditInternalDest: {
    component: EditInternalDest,
    path: "/farmsetup/destinations/internal/edit"
  },
  CreateExternalDest: {
    component: CreateExternalDest,
    path: "/farmsetup/destinations/external/create"
  },
  EditExternalDest: {
    component: EditExternalDest,
    path: "/farmsetup/destinations/external/edit"
  },
  CreateCommodity: {
    component: CreateCommodity,
    path: "/farmsetup/farminformation/commodities/create"
  },
  EditCommodity: {
    component: EditCommodity,
    path: "/farmsetup/farminformation/commodities/edit"
  },
  CreateFieldGroup: {
    component: CreateFieldGroup,
    path: "/farmsetup/farminformation/field-groups/create"
  },
  EditFieldGroup: {
    component: EditFieldGroup,
    path: "/farmsetup/farminformation/field-groups/edit"
  },
  CreateCommVariety: {
    component: CreateCommVariety,
    path: "/farmsetup/farminformation/commodity-varieties/create"
  },
  EditCommVariety: {
    component: EditCommVariety,
    path: "/farmsetup/farminformation/commodity-varieties/edit"
  },
  CreateCounterParty: {
    component: CreateCounterParty,
    path: "/farmsetup/counterparties/create"
  },
  EditCounterParty: {
    component: EditCounterParty,
    path: "/farmsetup/counterparties/edit"
  },
  FieldGroupInfo: {
    component: FieldGroupInfo,
    path: "/farmsetup/farminformation/field-groups/info"
  },
  Field: {
    component: Field,
    path: "/farmsetup/farminformation/field-groups/fields"
  },
  LoadNoIndicator: {
    component: LoadNoIndicator,
    path: "/farmsetup/farminformation/field-groups/indicators"
  },
  CreateField: {
    component: CreateField,
    path: "/farmsetup/farminformation/field-groups/fields/create"
  },
  EditField: {
    component: EditField,
    path: "/farmsetup/farminformation/field-groups/fields/edit"
  },
  CreateLoadNoIndicator: {
    component: CreateLoadNoIndicator,
    path: "/farmsetup/farminformation/field-groups/indicators/create"
  },
  EditLoadNoIndicator: {
    component: EditLoadNoIndicator,
    path: "/farmsetup/farminformation/field-groups/indicators/edit"
  },
  FarmSetupSubChild: {
    component:  (userDetail().roleName==="ACCOUNT_OWNER" || userDetail().roleName==="ACCOUNT_ADMIN" || userDetail().roleName==="FARM_EMPLOYEE")?FarmSetup:LoginHome,
    path: "/farmsetup/*"
  },
  RiskManagement: {
    component:  (userDetail().roleName==="ACCOUNT_OWNER" || userDetail().roleName==="ACCOUNT_ADMIN" || userDetail().roleName==="FARM_EMPLOYEE") ?RiskManagement:LoginHome,
    path: "/riskmanagement"
  },
  Reports: {
    component: Reports,
    path: "/reports"
  },
  SubFrams: {
    component: CreateSubFarm,
    path: "/createSubFarm"
  },
  SubFarmsList: {
    component: FarmsList,
    path: "/subFarmsList"
  },
  EditSubFarm: {
    component: EditSubFarm,
    path: "/subFarmsList/edit"
  },
  ChangeBillingPlan: {
    component: ChangeBillingPlan,
    path: "/settings/billing/changePlan"
  },
  CounterPartyBilling: {
    component: CounterPartyBilling,
    path: "/counterpartybillings"
  },
  Settings: {
    component: Settings,
    path: "/settings"
  },

  CreateUser: {
    component: CreateUser,
    path: "/settings/users/create"
  },
  EditUser: {
    component: EditUser,
    path: "/settings/users/edit"
  },

  SettingSubChild: {
    component: Settings,
    path: "/settings/*"
  },
  RiskManagementSubChild: {
    component: RiskManagement,
    path: "/riskmanagement/*"
  },
  Reconciliation: {
    component: Reconciliation,
    path: "/reconciliation"
  },
  UserManagement: {
    component: UserManagement,
    path: "/usermanagement"
  },
  FarmManagement: {
    component: FarmManagement,
    path: "/farmmanagement"
  },
  CreateMainFarm: {
    component: MainFarmForm,
    path: "/farmmanagement/createmainfarm"
  },
  EditMainFarm: {
    component: EditMainFarm,
    path: "/farmmanagement/edit"
  },
  CreateSubFarm: {
    component: CreateSubFarm,
    path: "/farmmanagement/createsubfarm"
  },
  EditAnyUser: {
    component: EditAnyUser,
    path: "/usermanagement/edit"
  },
  ChangePassword: {
    component: ChangePassword,
    path: "/usermanagement/changepassword"
  },
  AdminChangePassword: {
    component: ChangePassword,
    path: "/changepassword"
  },
  HarvestYearManagemnet: {
    component: HarvestYearManagemnet,
    path: "/harvestYearList"
  },
  ShowHelpText: {
    component: ShowHelpText,
    path: "/help"
  }
};



// WEBPACK FOOTER //
// ./src/routes/privateRoutes.js